import 'babel-polyfill'
import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
// import Raven from 'raven-js'
// import RavenVue from 'raven-js/plugins/vue'
import Vuelidate from 'vuelidate'
import BootstrapVue from 'bootstrap-vue/dist/bootstrap-vue'
import 'vue-awesome/icons'
import ComponentProvider from './ui/ComponentProvider'
import Router from 'vue-router'
import RouteBuilder from './router/RouteBuilder'
import Connection from './api/Connection'
import Api from './api/Api'
import ApiVuePlugin from './api/ApiVuePlugin'
import LocalizationVuePlugin from './ui/LocalizationVuePlugin'
import FormattersVuePlugin from './ui/FormattersVuePlugin'
import FlatpickrConfigVuePlugin from './ui/FlatpickrConfigVuePlugin'
import RavenErrorHandlerPlugin from './exceptions/RavenErrorHandlerPlugin'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Store from './store/Store'
import VuePaginate from 'vue-paginate'


console.log('SPEA ver: 1.1')
//alert('spea: remove me ccc');

Vue.use(RavenErrorHandlerPlugin, {
// raven: Raven
})

// load common components
ComponentProvider.register()

// register vue plugins
Vue.use(Vuex)
Vue.use(Router)
Vue.use(VueAxios, axios)
Vue.use(FormattersVuePlugin)
Vue.use(Vuelidate)
Vue.use(BootstrapVue)
Vue.use(FlatpickrConfigVuePlugin)
Vue.use(VuePaginate)

// set up API client
let connection = new Connection(
  axios,
  process.env.API_URL,
  process.env.API_PARTNER_KEY,
  parseInt(process.env.DEBUG_LOG_ENABLED),
  process.env.PROMOTION_RULE_TOKEN
)

let api = new Api(connection, parseInt(process.env.API_CACHE_TIME_NORMAL))
Vue.use(ApiVuePlugin, {
  api: api,
  connection: connection
})

// set up localisation
Vue.use(LocalizationVuePlugin, {api: api})

// set up store
let store = new Vuex.Store(new Store())

// set up routing
let routeBuilder = new RouteBuilder(store, connection)
let router = new Router({
  routes: routeBuilder.build()
})

// configure and create Vue root instance
Vue.config.productionTip = false
let root = new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: {
    App
  }
})

api.setEventBus(root)
export default root



// WEBPACK FOOTER //
// ./src/main.js